import { createFileRoute, redirect } from '@tanstack/react-router'

import { interactionsApi } from '@/api/interactions'

/**
 * `/echanges/{id}` : l'adresse courte d'un échange, depuis le calendrier ou
 * une notification. Elle mène à la page de l'échange sous son client, la
 * seule qui existe.
 */
export const Route = createFileRoute('/_app/echanges/$interactionId')({
  loader: async ({ params }) => {
    const interaction = await interactionsApi.get(params.interactionId)
    throw redirect({
      to: '/clients/$clientId/echanges/$interactionId',
      params: { clientId: interaction.client_id, interactionId: interaction.id },
      replace: true,
    })
  },
  component: () => null,
})
